module.exports = __webpack_public_path__ + "static/media/buy-tickets-bg.c8e23bcd.jpg";